export default __webpack_public_path__ + "media/images/dividers/green-tear-7320e9727abeebb60b90be04d1486723.svg";